import { render, staticRenderFns } from "./MegaphoneIcon.vue?vue&type=template&id=4b868964&"
import script from "./MegaphoneIcon.vue?vue&type=script&lang=js&"
export * from "./MegaphoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports